<!--
 * @Descripttion: 基础弹窗模版
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 19:17:41
 * @LastEditors: Li Yong
 * @LastEditTime: 2023-01-30 20:26:40
-->
<template>
	<el-dialog
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		width="600px"
		:before-close="handleClose"
		:show-close="showClose"
		:close-on-click-modal="closeOnClickModal"
	>
		<div style="padding:4px" class="dialogDelayPromotion_text">
			<Tip content="延长托管时间的申请需合作方审核，通过后立即生效，3天未处理则视为拒绝" />
			<div style="margin-bottom:28px; margin-top:24px"> 当前推广结束时间：{{ this.info.promotion_end_date }} </div>
			<div>
				延长推广结束时间：
				<el-date-picker
					style="width:300px"
					v-model="time"
					type="date"
					placeholder="选择日期"
					:picker-options="pickerOptions"
					value-format="yyyy-MM-dd"
				>
				</el-date-picker>
			</div>
		</div>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="confirm" :loading="loading">提交申请</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from 'lodash';
import { delayPromotion } from '@/api/shopManage';
export default {
	data() {
		return {
			title: '延长推广时间', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态
			time: '',
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 8.64e7;
				},
			},
			info: {},
		};
	},
	computed: {},
	created() {
		this.initData();
	},
	mounted() {},

	methods: {
		// 主动显示弹窗
		show(info) {
			this.info = info;
			this.visible = true;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm: debounce(async function() {
			// todo
			// 按钮loading开启
			if (!this.time) {
				return this.$message.error('请选择推广结束时间');
			}
			this.loading = true;
			try {
				// todo
				await delayPromotion({
					activity_id: this.info.outer_activity_id,
					product_id: this.info.product_id,
					third_product_id: this.info.third_product_id,
					platform_id: this.info.platform_id,
					extend_time: this.time,
				});
				// 刷新列表（外部重新获取数据）
				this.$emit('refreshList');
				this.$message.success('提交成功');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading关闭
				this.loading = false;
			}
		}, 300),
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 弹窗是否添加到body节点下
			this.appendToBody = true;
			// 是否展示弹窗右上角关闭图标
			this.showClose = true;
			// 点击蒙版是否关闭
			this.closeOnClickModal = false;
		},
	},
	components: {
	},
};
</script>
<style scoped>
.dialogDelayPromotion_text {
	color: #1d1f23;
	font-size: 14px;
}
</style>
